import { render } from "./RelatorioUsoConsultasAssinaturasView.vue?vue&type=template&id=5b2551b8"
import script from "./RelatorioUsoConsultasAssinaturasView.vue?vue&type=script&lang=js"
export * from "./RelatorioUsoConsultasAssinaturasView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__